// extracted by mini-css-extract-plugin
export var attachment = "_kh-a";
export var emailContainer = "_kh-4";
export var emailContentPaddedContainer = "_kh-b";
export var emailHeader = "_kh-6";
export var emailIframe = "_kh-3";
export var emailInfoIcon = "_kh-9";
export var emailShortenedSummary = "_kh-e";
export var infoDropdown = "_kh-0";
export var infoRowBoundedContent = "_kh-d";
export var internal = "_kh-5";
export var merchant = "_kh-8";
export var messageInputContainer = "_kh-h";
export var normal = "_kh-7";
export var replyCard = "_kh-f";
export var subtleButton = "_kh-1";
export var subtleButtonIconContainer = "_kh-2";
export var toggleViewRepliesButton = "_kh-c";
export var wrappingText = "_kh-g";